// @flow

const BACKEND_URL_FOR_PREPROD = 'https://yoroi-backend-zero-preprod-prod.emurgornd.com/cexplorer-pool-list';
const BACKEND_URL_FOR_MAINNET = 'https://zero.yoroiwallet.com/cexplorer-pool-list'

module.exports = {
  BACKEND_URL_FOR_PREPROD,
  BACKEND_URL_FOR_MAINNET,
};
